import React, { Component, ReactElement } from 'react'
import { LanguageContextProvider } from '../../React/Common/Contexts'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'
import { LicenseManagementFeatureGate } from '../Guards/LicenseManagementFeatureGate'
import { LicenseManagement } from '../Components/Organisms/LicenseManagement/LicenseManagement'

/**
 * Routed licence management page.
 */
@Route(RouteID.LICENCES)
export class LicenseManagementPage extends Component {
    /**
     * Renders the guarded routed page.
     *
     * @returns Licence management page component tree.
     */
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.LICENCES}>
                <LicenseManagementFeatureGate>
                    <LanguageContextProvider>
                        <LicenseManagement />
                    </LanguageContextProvider>
                </LicenseManagementFeatureGate>
            </RouteGuard>
        )
    }
}
